import { /* React,*/ Component } from "react";

class LinkDocument extends Component {
  render() {
    return null;
    /*
      return (
      <div>
        <h2 className="subtitleSection">Collega a un altro documento</h2>
        <div> Qui content </div>
      </div>
    );
    */
  }
}

export default LinkDocument;
